var map = {
	"./fr-audi/customerHappinessIndex.json": 20461,
	"./fr-cupra/customerHappinessIndex.json": 37101,
	"./fr-seat/customerHappinessIndex.json": 39133,
	"./fr-skoda/customerHappinessIndex.json": 29450,
	"./fr-vw/customerHappinessIndex.json": 21543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65717;